import * as z from "zod";
import { requiredString } from "components/form/utils";

export const companySchema = z.object({
  name: requiredString(),
  website: z.string().url("Invalid website URL").optional().or(z.literal("")).nullable(),
  phone: z.string().optional().nullable(),
  email: z.string().email("Invalid email format").optional().or(z.literal("")).nullable(),
  tax_number: z.string().optional().nullable(),
  address_line_1: requiredString(),
  address_line_2: z.string().optional().nullable(),
  city: requiredString(),
  state: requiredString(),
  zipcode: requiredString(),
  country_id: requiredString(),
});

// export const companyCreateSchema = companySchema;
// export const companyUpdateSchema = companySchema.partial();
